import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Collapse, Drawer, Descriptions, Divider, Empty, Timeline, Typography, Tag } from 'antd'
import ReactHtmlParser from 'react-html-parser';
import { renderAppointmentName, isValidDate, renderAppointmentStatus } from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import CreatedAtCell from '../CreatedAtCell';
import AppointmentServicesCell from './AppointmentServicesCell';
import { getAppointmentDoctorRoleGroups } from '@/components/customer-services/customerServiceDoctorRoleHelpers';
import { buildAppointmentStaffHistoryRows, getAppointmentStaffHistoryAction } from './appointmentStaffHistoryHelpers';

const { Paragraph } = Typography;

class AppointmentDetail extends Component {

    constructor() {
        super();
        this.state = {
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    render() {
        var { visible, currentItem } = this.props;

        const RowItem = ({ label, children }) => (
            <Descriptions.Item label={label}>
                {children || '-'}
            </Descriptions.Item>
        );

        const customer = currentItem?.customer || {};

        const getAllStaffNames = (services = [], key) => {
            return services
                .flatMap(s => s?.[key] || [])
                .map(p => p?.full_name)
                .filter(Boolean)
                .join(', ');
        };

        const getDoctorNamesByRole = (services = [], role) => [...new Set(services
            .flatMap(service => getAppointmentDoctorRoleGroups(service))
            .filter(group => group.key === role)
            .flatMap(group => group.people.map(person => person.name))
        )].join(', ');

        const staffHistoryRows = buildAppointmentStaffHistoryRows(currentItem?.staff_events);

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi tiết lịch hẹn"
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '60%'}
                    bodyStyle={{ padding: 16 }}
                >
                    {!visible ? null : (
                        <>
                            {/* ===== THÔNG TIN KHÁCH HÀNG ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin khách hàng</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Tên khách hàng">
                                    {customer?.full_name}
                                </RowItem>

                                <RowItem label="Mã khách hàng">
                                    <Paragraph
                                        style={{ margin: 0 }}
                                        copyable={{
                                            text: customer?.code,
                                            tooltips: false
                                        }}
                                    >
                                        <Tag color="blue">{customer?.code}</Tag>
                                    </Paragraph>
                                </RowItem>

                                <RowItem label="Cơ sở khách hàng">
                                    {customer?.branch?.name}
                                </RowItem>

                                <RowItem label="Cơ sở thực hiện">
                                    {currentItem?.branch?.name}
                                </RowItem>
                            </Descriptions>

                            {/* ===== THÔNG TIN LỊCH HẸN ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin lịch hẹn</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Kiểu lịch hẹn">
                                    {renderAppointmentName(currentItem?.name)}
                                </RowItem>

                                <RowItem label="Trạng thái">
                                    {renderAppointmentStatus(currentItem?.status)}
                                </RowItem>

                                <RowItem label="Thời gian">
                                    {isValidDate(currentItem?.scheduled_at)}
                                </RowItem>

                                <RowItem label={`Thời điểm ${currentItem?.name === 'GOILAI' ? 'gọi' : 'đến'}`}>
                                    {isValidDate(currentItem?.arrived_at)}
                                </RowItem>
                            </Descriptions>
                            {/* ===== NHÂN SỰ ===== */}
                            <Divider orientation="left" orientationMargin={0}>Nhân sự thực tế của lịch hẹn</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Bác sĩ khám">
                                    {getDoctorNamesByRole(currentItem?.services, 'examination') || '-'}
                                </RowItem>
                                <RowItem label="Bác sĩ điều trị">
                                    {getDoctorNamesByRole(currentItem?.services, 'treatment') || '-'}
                                </RowItem>
                                <RowItem label="Bác sĩ cắm trụ">
                                    {getDoctorNamesByRole(currentItem?.services, 'implant_placement') || '-'}
                                </RowItem>
                                <RowItem label="Bác sĩ phục hình">
                                    {getDoctorNamesByRole(currentItem?.services, 'prosthetic_restoration') || '-'}
                                </RowItem>

                                <RowItem label="Phụ tá">
                                    {getAllStaffNames(currentItem?.services, 'assistants') || '-'}
                                </RowItem>
                                <RowItem label="Dịch vụ">
                                    <AppointmentServicesCell services={currentItem?.services || []} />
                                </RowItem>
                            </Descriptions>

                            {/* ===== THÔNG TIN HỆ THỐNG ===== */}
                            <Divider orientation="left" orientationMargin={0}>Thông tin hệ thống</Divider>
                            <Descriptions
                                bordered
                                size="small"
                                column={1}
                                labelStyle={{ width: 180, fontWeight: 500 }}
                            >
                                <RowItem label="Ngày tạo">
                                    <CreatedAtCell
                                        createdAt={currentItem?.created_at}
                                        user={currentItem?.created_user}
                                    />
                                </RowItem>

                                <RowItem label="Cập nhật lần cuối">
                                    <CreatedAtCell
                                        createdAt={currentItem?.updated_at}
                                        user={currentItem?.updated_user}
                                    />
                                </RowItem>

                            </Descriptions>

                            {/* ===== GHI CHÚ ===== */}
                            <Divider orientation="left" orientationMargin={0}>Ghi chú</Divider>
                            <div
                                style={{
                                    padding: 12,
                                    background: '#fafafa',
                                    border: '1px solid #f0f0f0',
                                    borderRadius: 6,
                                    minHeight: 80
                                }}
                            >
                                {currentItem?.note
                                    ? ReactHtmlParser(currentItem.note)
                                    : <em style={{ color: '#999' }}>Không có ghi chú</em>}
                            </div>

                            <Collapse bordered={false} style={{ marginTop: 16, background: '#fff', borderRadius: 12, overflow: 'hidden' }}>
                                <Collapse.Panel
                                    key="staff-history"
                                    header={<strong>Lịch sử nhân sự thực hiện ({staffHistoryRows.length} lần)</strong>}
                                >
                                    {staffHistoryRows.length ? (
                                        <Timeline>
                                            {staffHistoryRows.map(row => {
                                                const action = getAppointmentStaffHistoryAction(row);
                                                return (
                                                    <Timeline.Item key={row.key} color="blue">
                                                        <div style={{ marginBottom: 10 }}>
                                                            <strong>Thay đổi: {isValidDate(row.eventAt)}</strong>
                                                            {row.actor?.full_name ? <div style={{ color: '#595959', marginTop: 2 }}>Người thực hiện: {row.actor.full_name}</div> : null}
                                                        </div>
                                                        <div style={{ padding: '10px 12px', border: '1px solid #f0f0f0', borderRadius: 8, overflowWrap: 'anywhere' }}>
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                                                                <Tag color={action.color} style={{ marginRight: 0 }}>{action.label}</Tag>
                                                                <strong>{row.label}</strong>
                                                            </div>
                                                            <div style={{ fontSize: 15, color: '#262626' }}>
                                                                <strong>{row.removed.join(', ') || 'Chưa phân công'}</strong>
                                                                <span style={{ color: '#8c8c8c', margin: '0 6px' }}>→</span>
                                                                <strong>{row.assigned.join(', ') || 'Không còn phụ trách'}</strong>
                                                            </div>
                                                        </div>
                                                    </Timeline.Item>
                                                );
                                            })}
                                        </Timeline>
                                    ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có lịch sử nhân sự thực hiện" />}
                                </Collapse.Panel>
                            </Collapse>
                        </>
                    )}
                </Drawer >
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AppointmentDetail' })(AppointmentDetail));
